define([
    'backbone',
    'errors'
], (Backbone, Errors) => {

    const urlError = function () {
        throw new Error('A "url" property or function must be specified');
    };

    const isSubClass = function (a, b) {
        return a.prototype instanceof b || a === b;
    };
    const isCollection = function (obj) {
        return isSubClass(obj, Backbone.Collection);
    };
    const isModel = function (obj) {
        return isSubClass(obj, Backbone.Model);
    };

    return Backbone.Model.extend({
        apiPrefix: '/api',
        namespace: null,

        initialize () {
            if (this.nested) {
                _.each(this.nested, function (Class, key) {
                    const obj = this[key] = new Class(this.get(key));
                    this.listenTo(obj, 'change add remove reset', function () {
                        this.set(key, obj.toJSON(), {sender: this});
                    });
                }, this);
                this.listenTo(this, 'change', this.propagateChanges);
                this.listenTo(this, 'error invalid', this.propagateErrors);
            }
        },

        sync (method, model, options) {
            if (!options.url) {
                let base = _.result(this, 'apiPrefix');
                if (this.namespace) {
                    base += '/{0}'.format(_.result(this, 'namespace'));
                }
                if (options._url) {
                    options.url = base + options._url;
                    delete options._url;
                } else {
                    options.url = base + (_.result(model, 'url') || urlError());
                }
            }
            return Backbone.Model.prototype.sync.apply(this, arguments);
        },

        prepareCall (options) {
            if (options && options.data) {
                const url = options.url || _.result(this, 'url') || urlError();
                const params = $.param(options.data);
                options._url = params ? '{0}?{1}'.format(url, params) : url;
                delete options.data;
            }
        },

        // overloaded save and destroy methods for gentle passing query params in options.data
        save (key, val, options) {

            // Handle both `"key", value` and `{key: value}` -style arguments.
            if (key === null || typeof key === 'object') {
                options = val;
            }
            this.prepareCall(options);
            return Backbone.Model.prototype.save.call(this, key, val, options);
        },

        destroy (options) {
            this.prepareCall(options);
            return Backbone.Model.prototype.destroy.call(this, options);
        },

        propagateChanges (model, options) {
            if (options.sender === this) {
                return;
            }

            _.each(this.nested, function (Class, key) {
                if (this.hasChanged(key)) {
                    const obj = this[key]; const value = this.get(key);
                    if (isModel(Class)) {
                        obj.clear({silent: true}).set(value);
                    } else if (isCollection(Class)) {
                        obj.reset(value);
                    }
                }
            }, this);
        },

        propagateErrors (model, response) {
            if (!response.status || response.status < 500) {
                const errors = Errors.getErrors(response);

                _.each(this.nested, function (Class, key) {
                    if (_.isObject(errors[key])) {
                        if (isModel(Class)) {
                            this[key].trigger('invalid', this[key], Errors.responseFromErrors(errors[key]));
                        } else if (isCollection(Class) && !_.isArray(errors[key])) {
                            _.each(errors[key] || {}, function (error, index) {
                                const item = this[key].at(Number(index) - 1);
                                item.trigger('invalid', item, Errors.responseFromErrors(error));
                            }, this);
                        }
                    }
                }, this);
            }
        },

        parse (response, options) {
            _.each(this.nested || {}, (Class, key) => {
                if (key in response) {

                    /*
                     * Model can be not initialized yet.
                     * Collection.parse creates models with attributes.
                     * In this case parse called at first, then initialize.
                     */
                    response[key] = Class.prototype.parse(response[key], options);
                }
            }, this);

            return Backbone.Model.prototype.parse.apply(this, arguments);
        },

        // Simplified version. Backbone 1.3.3 code is more generic.
        pick () {
            return _.pick(this.toJSON(), ...arguments);
        }
    });
});
